NIRV.copyToClipboard = async ({ showParentName, showTags }) => {
  let text = [];

  function renderTitle() {
    const name = $('#cbar .tasklist .name').text().trim();
    const fallback = $('#cbar h2').text().trim();
    return '\n# ' + (name || fallback) + '\n';
  }

  function renderTask($task) {
    const id = $task.attr('taskid');
    const task = NIRV.tasks[id];
    const parentname = $task.find('.parentname:visible').text().trim();
    const note = $task.find('.note').text().trim();
    const infinity = $task.find('.note.infinity').length > 0;
    const double = $task.find('.note.double').length > 0;

    let str = '';

    // Reference item
    if ($task.hasClass('reflist') || $task.hasClass('refitem')) {
      str = '- ';
    }
    // Completed task
    else if ($task.hasClass('completed')) {
      str = '- [x] ';
    }
    // Incomplete task
    else {
      str = '- [ ] ';
    }

    str += task.startdate ? `${formatYMD(task.startdate).numeric} ` : '';
    str += task.seqt != 0 ? `${formatYMD(today()).numeric} ` : '';
    str += task.name + ' ';
    str += showParentName && parentname ? `(${parentname}) ` : '';
    str += task.duedate ? ` (due: ${formatYMD(task.duedate).numeric}) ` : '';

    if (showTags) {
      const tags = task.__tags__().split(',');
      if (tags.length > 0) {
        str += tags
          .map((tag) => {
            const tagName = tag.trim();
            return tagName ? `#${tagName}` : '';
          })
          .join(' ');
      }
    }

    // Preserve note formatting
    if (note) {
      let formattedNote = '';

      if (double) {
        formattedNote =
          // '\t' +
          task.note
            .substr(0, 72) // limit to n characters
            .split('\n')
            .map((line) => '  ' + line) // indent each line
            .join(' ');
        str += '\n' + formattedNote;
        str += task.note.length > 72 ? '...' : '';
      }

      if (infinity) {
        formattedNote = task.note
          .split('\n')
          .map((line) => '  ' + line) // ? indent each line
          .join('  \n');
        str += '\n\n' + formattedNote;
        str += '\n';
      }
    }

    return str + '  ';
  }
  // Copy only highlighted tasks
  if (NIRV.highlighted_tasks().length > 0) {
    $('#tasklists .task.ui-selected').each(function () {
      text.push(renderTask($(this)));
    });
  }

  // Copy full view
  else {
    text.push(renderTitle());

    $('#tasklists .tasklist:not(.empty)').each(function () {
      const $tasklist = $(this);
      const $tasks = $tasklist.find('li.task:visible');
      const tasklistName = $tasklist.find('.title').text().trim();

      if ($tasks.length === 0) {
        return;
      }

      if (tasklistName) {
        text.push('\n' + tasklistName + '\n');
      }

      $tasks.each(function () {
        text.push(renderTask($(this)));
      });
    });
  }

  function normalizeLineBreaks(text) {
    return text.replace(/(\n\s*){3,}/g, '\n\n');
  }

  // Copy to clipboard
  try {
    await navigator.clipboard.writeText(normalizeLineBreaks(text.join('\n')));
    console.log('Copied to clipboard!');
  } catch (err) {
    console.error('Failed to copy!', err);
  }
};
